<div class="chips">
  @for (tag of chips; track tag) {
    <div class="chips-item">
      {{ $any(tag).title }}
    </div>
  }

  @if (count && items.length - count > 0) {
    <span class="chips-more">+{{ items.length - count }}</span>
  }
</div>
